import { type Image } from '@tmdb-graphql-api/schema/types';
import { ImageSize, ProfileSize } from '#enums/imageSizes.ts';
import { buildImagePath } from '#helpers/buildImagePath.ts';
import { type Config } from '#types.ts';
import { type PersonProfilesData } from '../types.ts';

export const formatProfiles = (data: PersonProfilesData | null | undefined, config: Config) =>
  data
    ? data.person.profiles
        .reduce((acc: string[], profile: Image | undefined) => {
          if (!profile) {
            return acc;
          }

          const imagePath = buildImagePath(profile.filePath, ImageSize.Profile, ProfileSize.LG, config.images);
          acc.push(imagePath);
          return acc;
        }, [])
        .reverse()
    : [];
